import { useEffect, useRef, useState } from 'react';

// Лёгкий reveal-on-scroll без сторонних зависимостей.
// Возвращает ref и булевый флаг видимости, навешиваем классы анимации
// в Tailwind через data-reveal атрибут (см. styles/index.css).
export function useReveal<T extends HTMLElement = HTMLDivElement>(options?: {
  threshold?: number;
  rootMargin?: string;
  once?: boolean;
}) {
  const ref = useRef<T | null>(null);
  const [visible, setVisible] = useState(false);
  const once = options?.once ?? true;

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            if (once) io.unobserve(entry.target);
          } else if (!once) {
            setVisible(false);
          }
        });
      },
      {
        threshold: options?.threshold ?? 0.12,
        rootMargin: options?.rootMargin ?? '0px 0px -10% 0px',
      },
    );
    io.observe(node);
    return () => io.disconnect();
  }, [once, options?.threshold, options?.rootMargin]);

  return { ref, visible } as const;
}
